import {
  AdminStipendExpenseFilterInput,
  useStipendExpensesByViewForReportingQuery,
} from "@common/utils/graphql";
import { useMemo } from "react";

type UseStipendExpensesSpendTableQueryProps = {
  filters?: AdminStipendExpenseFilterInput;
  currentPage: number;
};

export const useStipendExpensesSpendTableQuery = ({
  filters,
  currentPage,
}: UseStipendExpensesSpendTableQueryProps) => {
  const {
    data: rawData,
    loading,
    error: graphqlError,
  } = useStipendExpensesByViewForReportingQuery({
    variables: {
      filters,
      pagination: {
        offset: currentPage * 10,
        pageSize: 10,
      },
    },
  });

  const expenses = useMemo(
    () =>
      rawData?.stipendExpensesByView.__typename ===
      "QueryStipendExpensesByViewSuccess"
        ? rawData.stipendExpensesByView.data.stipendExpenses
        : [],
    [rawData],
  );

  const hasMorePages = useMemo(() => {
    return rawData?.stipendExpensesByView.__typename ===
      "QueryStipendExpensesByViewSuccess"
      ? rawData.stipendExpensesByView.data.hasMore
      : false;
  }, [rawData]);

  const error = useMemo(
    () =>
      !!graphqlError ||
      rawData?.stipendExpensesByView.__typename?.includes("Error"),
    [graphqlError, rawData],
  );

  return { expenses, loading, error, hasMorePages };
};

export type ExpenseFromStipendExpensesSpendTableQuery = ReturnType<
  typeof useStipendExpensesSpendTableQuery
>["expenses"][number];
